<template>
    <div class="phone-contain">
        <div class="header">
            <img class="header-logo" src="./../assets/linenazi_icon.png" alt="" @click="navigateIndex">
            <div class="header-title" @click="navigateIndex">灵能纳茨综合服务网</div>
            <a class="header-button" href="https://edgehacker.taobao.com" target="_blank">企业店铺</a>
        </div>
        <div class="main">
            <div class="headline-title">
                <div class="headline-title-content">
                    LINENAZI
                </div>
            </div>
            <div class="app-menu">
                <div class="product-box">
                    <div class="product">
                        <img src="./../assets/app/official_app_icon.png" alt="">
                        <div class="product-name">秒数联盟数学派</div>
                        <div class="product-information">
                            <span>2023</span>
                            <span>边缘骇客实验室</span>
                        </div>
                    </div>
                    <div class="product">
                        <img src="./../assets/app/cat_app_icon.png" alt="">
                        <div class="product-name">迷你英语单词猫</div>
                        <div class="product-information">
                            <span>2023</span>
                            <span>边缘骇客实验室</span>
                        </div>
                    </div>

                    <div class="product">
                        <img src="./../assets/app/word_app_icon.png" alt="">
                        <div class="product-name">醒语开源英语网</div>
                        <div class="product-information">
                            <span>2024</span>
                            <span>热氧细胞工作室</span>
                        </div>
                    </div>
                    <div class="product">
                        <img src="./../assets/app/cloud_app_icon.png" alt="">
                        <div class="product-name">亿题云资料宝库</div>
                        <div class="product-information">
                            <span>2023</span>
                            <span>边缘骇客实验室</span>
                        </div>
                    </div>
                    <div class="product">
                        <img src="./../assets/app/livehelper_app_icon.png" alt="">
                        <div class="product-name">直播互动助手</div>
                        <div class="product-information">
                            <span>2024</span>
                            <span>边缘骇客实验室</span>
                        </div>
                    </div>
                    <div class="product">
                        <img src="./../assets/app/linenazi_app_icon.png" alt="">
                        <div class="product-name">灵能纳茨综合服务网</div>
                        <div class="product-information">
                            <span>2024</span>
                            <span>灵能纳茨工作室</span>
                        </div>
                    </div>
                    <div class="product">
                        <img src="./../assets/app/edgehacker_app_icon.png" alt="">
                        <div class="product-name">编程英语研究网</div>
                        <div class="product-information">
                            <span>2024</span>
                            <span>边缘骇客实验室</span>
                        </div>
                    </div>
                    <div class="product">
                        <img src="./../assets/app/planet_app_icon.png" alt="">
                        <div class="product-name">数学派解题星球</div>
                        <div class="product-information">
                            <span>2023</span>
                            <span>边缘骇客实验室</span>
                        </div>
                    </div>
                    <div class="product">
                        <img src="./../assets/app/classmate_app_icon.png" alt="">
                        <div class="product-name">云学霸陪学网</div>
                        <div class="product-information">
                            <span>2025</span>
                            <span>边缘骇客实验室</span>
                        </div>
                    </div>

                    <div class="product">
                        <img src="./../assets/app/iding_app_icon.png" alt="">
                        <div class="product-name">迪醒智能排队助手</div>
                        <div class="product-information">
                            <span>2025</span>
                            <span>热氧细胞工作室</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    beforeCreate() {

    },
    mounted() {
    }
}
</script>

<style scoped>
.phone-contain {
    background-color: #F1F6FD;
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    font-family: "linenazi";
    overflow-y: scroll;
    min-width: 360px;
    max-width: 768px;
    margin: 0 auto;
    box-sizing: border-box;
    background-size: cover;
}

.header {
    height: 60px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    transition: all 0.5s;
    box-shadow: 0 2px 8px 0 rgb(99 99 99 / 0.1);
    background-color: rgba(255, 255, 255, 1);
    z-index: 1;
    position: sticky;
    top: 0;
}

.header-logo {
    width: 40px;
    height: 40px;
    display: flex;
    cursor: pointer;
    border-radius: 5px;
}

.header-title {
    margin-left: 20px;
    margin-right: auto;
    cursor: pointer;
    color: #0079BA;
}

.header-button {
    margin-left: 20px;
    padding: 0 10px;
    height: 30px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    border: 2px solid #0079BA;
    box-sizing: border-box;
    color: #0079BA;
    cursor: pointer;
    text-decoration: none;
}

.main {
    box-sizing: border-box;
    text-align: center;
    padding: 5px;
}

.headline-title {
    margin: 40px auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    margin-bottom: 40px;
}

.headline-title-content {
    font-size: 50px;
    background-image: url("./../assets/title.gif");
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: "title";
    font-weight: bolder;
}

.app-menu {
    width: 100%;
    margin: 0 auto;
    padding-bottom: 15px;
}

.product-box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.product {
    width: calc(50% - 10px);
    margin: 5px;
    background-color: white;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px 0 rgb(99 99 99 / 0.1);
    cursor: pointer;
}

.product-name {
    margin-top: 10px;
    color: #454545;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.product-information {
    color: #CFD9E7;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.product-information span {
    font-size: 12px;
}

.product img {
    width: 60px;
    height: 60px;
    border-radius: 10px;
}
</style>